import { CatalogMapCatalogItemViewModel } from '@common/model/catalog/item/map.view';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import React from 'react';
import { useAuth } from 'src/features/auth';
import { useOpenCatalogItem } from 'src/features/catalogItem';

export const MAP_MARKER_CLICK_HANDLER_NAME = '__handleMapMarkerClick';

export const useMapMarkerClickHandler = () => {
  const authCase = useAuth();
  const isLoggedIn = useIsLoggedIn();
  const [catalogItemFeature] = useOpenCatalogItem();

  React.useEffect(() => {
    window[MAP_MARKER_CLICK_HANDLER_NAME] = async (catalogItem: CatalogMapCatalogItemViewModel, event: PointerEvent) => {
      event.preventDefault?.();
      event.stopPropagation?.();
      const catalogItemResult = await catalogItemFeature(catalogItem.id);
      catalogItemResult.tapError(() => {
        if (!isLoggedIn) {
          authCase();
        }
      });
    };

    return () => {
      delete window[MAP_MARKER_CLICK_HANDLER_NAME];
    };
  }, [catalogItemFeature, authCase, isLoggedIn]);
};
